import React, { useState } from 'react';
import axios from 'axios';

import '../components/VideoUploadSection.css'

const VideoUploadSection = ({uploadDisabled=false, keyId, name, initialData, uploadUrl, setUploadResult, clearOnSuccess=false}) => {

  if (initialData === null || initialData === undefined) {
    initialData = {
        'file': null,
        'name': '',
        'description': '',
        'placeholder': null,
        'isFree': false,
        'hasAds': false,
        'length': 0
    };
  }

  const [file, setFile] = useState(initialData['file']);
  const [episodeName, setEpisodeName] = useState(initialData['name']);
  const [description, setDescription] = useState(initialData['description']);
  const [preview, setPreview] = useState(initialData['placeholder']);
  const [isFree, setIsFree] = useState(initialData['isFree']);
  const [hasAds, setHasAds] = useState(initialData['hasAds']);
  const [length, setLength] = useState(initialData['length'])
  const [filesize, setFilesize] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [lastEpisodeName, setLastEpisodeName] = useState('');
  
  const buttonsDisabled = () => {
    return isUploading && !uploadDisabled;
  }

  const fieldsFilled = () => {
    return file !== null && length?.length > 0 && episodeName?.length > 0 && preview !== null;
  }

  const imgFormats = [".jpg", ".jpeg", ".gif", ".svg", ".png", ".tiff", ".webp", ".bmp"];
  // const vidFormats = {
  //   ".m3u8":  "application/x-mpegURL", 
  //   ".mp4":   "video/mp4", 
  //   ".mov":   "video/quicktime", 
  //   ".3gp":   "video/3gpp", 
  //   ".avi":   "video/x-msvideo", 
  //   ".wmv":   "video/x-ms-wmv", 
  //   ".mpeg":  "video/mpeg",
  //   ".flv":   "video/x-flv"
  // };

  const isImage = (filename) => {
    if(filename !== null) {
      for(let format of imgFormats) {
        if(filename.endsWith(format) || filename.startsWith("data:image/")) {
          return true;
        }
      }
    }
    return false;
  }

  const handleFileChange = (event) => {
    const f = event.target.files;
    if (f !== null && f !== undefined && f.length > 0) {      
      if(!isImage(f[0].name)) {
        setFile(f[0]);
        setFilesize(`${(f[0].size / 1000).toFixed(2)}KB`);
      }
    } 
    else {
      setFile(null);
      setFilesize('');
    }
  };

  const handleImageChange = (event) => {
    const f = event.target.files;
    if (f !== null && f !== undefined && f.length > 0) {      
      if(isImage(f[0].name)) {
        setPreview(f[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          setImagePreview(e.target.result);
        };
        reader.readAsDataURL(f[0]);
      }
    } 
    else {
      setImagePreview(null);
    }
  }

  const clearFileArea = () => {
    setFile(null);
  }

  const clearImageArea = () => {
    setImagePreview(null);
  }
  
  const handleNameChange = (e) => {
    const t = e.target.value;
    if (t !== null && t !== undefined) {
        setEpisodeName(t);
    }
  };

  const handleDescriptionChange = (e) => {
    const t = e.target.value;
    if (t !== null && t !== undefined) {
        setDescription(t);
    }
  };

  const handleLengthChange = (e) => {
    const t = e.target.value;
    if (t !== null && t !== undefined) {
      const validPattern = /^[0-9:]*$/;
      if(validPattern.test(t)) {
        setLength(t);
      }
    }
  }

  const handleAdsChange = (e) => {
    setHasAds(e.target.checked);
  }

  const handleFreeChange = (e) => {
    setIsFree(e.target.checked);
  }

  const handleUpload = async (e) => {
    if (!file || !episodeName || !preview || !length) {
      setUploadResult(false, "Please ensure name and length are correct, and file and preview are selected.")
      return;
    }

    e.preventDefault();

    setUploadSuccess(null);

    if (!file) {
      setUploadResult(false, 'Please select a file to upload');
      return;
    }

    const formData = new FormData();
    //TODO: Remove in large file uploader version
    formData.append('file', file);
    formData.append('name', episodeName);
    formData.append('description', description);
    formData.append('placeholder', preview);
    formData.append('isFree', isFree);
    formData.append('hasAds', hasAds);
    formData.append('length', length);

    try {
      setIsUploading(true);

      const token = localStorage.getItem('token');
      if (token) {        
        // Finally, upload the form metadata which will allow the episode converter to trigger
        const response = await axios.post(uploadUrl, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

        setUploadResult(true, response.data.status);
        setUploadSuccess(true);
      }
    } catch (error) {
      setUploadResult(false, error.response?.data?.detail || error.message);
      setUploadSuccess(false);
    } finally {
      setIsUploading(false);
      
      if(clearOnSuccess) {
        setFile(null);
        setPreview('');
        setImagePreview(null);
        setFilesize('');
        setLastEpisodeName(episodeName);
        setEpisodeName('');
        setDescription('');
        setIsFree(false);
        setHasAds(false);
        setLength(0);
      }
    }
  };

  return (
    <div>
      <h4>{name}</h4>
      {uploadSuccess !== null ? 
      <div className={uploadSuccess === true ? "UploadSuccess" : "UploadFail"}>
        "{lastEpisodeName}" {uploadSuccess === true ? ` uploaded successfully.` : ` failed to upload.`}
      </div>
      : <></>}
      <div className="UploadSection">

      

      <span className="UploadGroup">
        <div>
          { buttonsDisabled() ? <></>
          :
          <div> 
            <span className="HorizontalGroup BottomGap">
                {
                  file !== null && 
                  <>
                    <p>{file.name} ({filesize})</p>
                    <button className="CancelButton" onClick={clearFileArea} disabled={buttonsDisabled()}>✖</button>
                  </>
                } 
                <div>
                    <input type="file" accept="video/*|audio/*" id={`${keyId}-upload-video`} onChange={handleFileChange} className="UploadInput"/>
                    <label htmlFor={`${keyId}-upload-video`} className="UploadLabel">
                        Select episode file
                    </label>
                    
                </div>
            </span>
            <div className="BottomGap">
                <label htmlFor={`${keyId}-upload-name`} className="FieldLabel">
                    Episode name
                </label>
                <input type="text" id={`${keyId}-upload-name`} onChange={handleNameChange} className="TextInput"/>
            </div>
            <div className="BottomGap">
                <label htmlFor={`${keyId}-upload-description`} className="FieldLabel">
                    Episode description
                </label>
                <textarea type="text" cols={40} id={`${keyId}-upload-description`} onChange={handleDescriptionChange} className=""/>
            </div>
            <div className="BottomGap">
              <label htmlFor={`${keyId}-upload-length`} className="FieldLabel">
                Episode length (use hh:mm:ss)
              </label>
              <input type="text" id={`${keyId}-upload-length`} onChange={handleLengthChange} className="TextInput"/>
            </div>
            <div className="BottomGap">
                <input type="checkbox" id={`${keyId}-upload-free`} onChange={handleFreeChange} className=""/>
                <label htmlFor={`${keyId}-upload-free`} className="">
                    Is this a free episode?
                </label>
            </div>
            <div className="BottomGap">
                <input type="checkbox" id={`${keyId}-upload-ads`} onChange={handleAdsChange} className=""/>
                <label htmlFor={`${keyId}-upload-ads`} className="">
                    Show ads on this episode?
                </label>
            </div>
            <div className="BottomGap">
                {   imagePreview && 
                <>
                <img src={imagePreview} className="UploadPreviewImage" alt="Preview"/>
              
                <span className="HorizontalGroup">
                    <p className="UploadFilename">{preview?.name}</p>
                    <button className="CancelButton" onClick={clearImageArea} disabled={buttonsDisabled()}>✖</button>
                </span>
                </>
                }
                
                <input type="file" accept="image/*" id={`${keyId}-upload-preview`} onChange={handleImageChange} className="UploadInput"/>
                <label htmlFor={`${keyId}-upload-preview`} className="UploadLabel">
                    Select preview image
                </label>
            </div>
          </div>
          }
          { isUploading ? 
            <span><div className="LoadingSpinner">⧖</div> Uploading... {uploadPercentage}% </span> :
            (buttonsDisabled() || !fieldsFilled() ? 
            <button disabled className="StandardButton" >Upload</button>
            :
            <button onClick={handleUpload} className="StandardButton" >Upload</button>
          )
          }
          
        </div>
      </span>
    </div>
    </div>
  );
}

export default VideoUploadSection;
